module.exports = __webpack_public_path__ + "images/category_lp/watch/omega_samples/main_sp_30708443241bb8186f15db428babc1e8.jpg";